import { makeStyles } from "@material-ui/core/styles";

// Mesmo padrão visual do ChatiaPopover (drop dos cards do Kanban)
const useFilterDropdownStyles = makeStyles((theme) => {
  const isDark = theme.mode === "dark" || theme.palette.type === "dark";
  return {
    paper: {
      borderRadius: 14,
      boxShadow: "0 10px 36px rgba(0,0,0,0.14)",
      border: "none",
      background: isDark ? (theme.palette.darkDialogSurface || "#121212") : "#ffffff",
      backgroundImage: "none",
      marginTop: 8,
      overflow: "hidden",
      // ---- Autocomplete listbox ----
      "& .MuiAutocomplete-listbox": {
        padding: 6,
        ...theme.scrollbarStylesSoft,
        "& .MuiAutocomplete-option": {
          borderRadius: 8,
          padding: "9px 12px",
          marginBottom: 4,
          fontSize: 14,
          fontWeight: 500,
          color: isDark ? "#ffffff" : "#1a1a1a",
          "&:hover, &[data-focus='true']": {
            background: isDark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.04)",
          },
          "&[aria-selected='true']": {
            background: "rgba(6, 207, 156, 0.10)",
          },
          "&[aria-selected='true']:hover": {
            background: "rgba(6, 207, 156, 0.15)",
          },
        },
      },
      // ---- Select MenuList ----
      "& .MuiList-root": {
        padding: 6,
        "& .MuiMenuItem-root": {
          borderRadius: 8,
          padding: "9px 12px",
          marginBottom: 4,
          fontSize: 14,
          fontWeight: 500,
          color: isDark ? "#ffffff" : "#1a1a1a",
          "&:hover": {
            background: isDark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.04)",
          },
          "&.Mui-selected": {
            background: "rgba(6, 207, 156, 0.10)",
          },
          "&.Mui-selected:hover": {
            background: "rgba(6, 207, 156, 0.15)",
          },
        },
      },
    },
  };
});

export default useFilterDropdownStyles;
